import styled from 'styled-components';

export const StyledFormLabel = styled.label`
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#4B5563')};
`;
